import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=eeb2e386&"
import script from "./Project.vue?vue&type=script&lang=js&"
export * from "./Project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eeb2e386')) {
      api.createRecord('eeb2e386', component.options)
    } else {
      api.reload('eeb2e386', component.options)
    }
    module.hot.accept("./Project.vue?vue&type=template&id=eeb2e386&", function () {
      api.rerender('eeb2e386', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/views/Project.vue"
export default component.exports